export default __webpack_public_path__ + "static/media/slide5.65f7baf1.png";